import { AiOutlineLink, AiFillGithub } from "react-icons/ai";

import { StyledCard } from "./styles";

function ProjectCard({proj}) {
  return (
      <StyledCard>
        <img src={proj?.image} alt="" />
        <div className="projectInfo">
          <h1>{proj?.title} </h1>
          <p className="description"><span className="icon">{'>'}</span> {proj?.description} </p>
          <p className="techStack"><span className="icon">{'>'}</span> Tech Stack: HTML, CSS, JavaScript, React</p>
          <div className="externLinks">
            <div>
              <AiOutlineLink />
              <a href={proj?.url} target={"_blank"}>
                Aplicação
              </a>
            </div>
            <div>
              <AiFillGithub />
              <a href={proj?.repositorie} target={"_blank"}>
                Código
              </a>
            </div>
          </div>
        </div>
      </StyledCard>
  );
}

export default ProjectCard;
